/* eslint-disable indent */
import styled from 'styled-components'

export const Style = styled.div`
  position: relative;
  display: flex;
  margin: 125px 0 20px 0;
  @media screen and (min-width: 765px) and (max-width: 1116px) {
    margin: 120px 0 20px 0;
  }
  > img {
    position: absolute;
    bottom: 0;
    z-index: -1;
    width: 100%;
    left: 0;
    right: 0;
  }
  .card {
    box-shadow: ${props =>
      props.boxShadow || '0 10px 10px 0 rgba(255, 115, 0, 0.2)'};
    border: ${props => props.border || ' solid 1px #e3dbff'};
    background-color: #fff;
    padding: 40px;
    @media screen and (min-width: 320) and (max-width: 765px) {
      padding: 20px;
    }
    .tag {
      font-family: 'Open Sans';
      font-size: 20px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #ff7400;
      margin-bottom: 40px;
    }
    .title {
      font-family: 'Open Sans';
      margin-bottom: 10px;
      font-size: 30px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #333333;
    }
  }
  .link-apps {
    display: flex;
    width: 100%;
    a {
      margin-top: 10px;
      margin-right: 10px;
      width: 165px;
      > img {
        display: block;
        width: 100%;
      }
    }
    @media screen and (min-width: 320px) and (max-width: 756px) {
      a {
        width: 50%;
      }
    }
  }
  .image {
    width: 100%;
    display: block;
    @media screen and (min-width: 320px) and (max-width: 990px) {
      display: none;
    }
  }
  .end {
    align-items: flex-end;
  }
`
